import { toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, normalizeStyle as _normalizeStyle, resolveComponent as _resolveComponent, withModifiers as _withModifiers, createVNode as _createVNode, withCtx as _withCtx, createSlots as _createSlots, mergeProps as _mergeProps, createBlock as _createBlock } from "vue"

const _hoisted_1 = ["aria-label"]
const _hoisted_2 = {
  key: 0,
  class: "gs-color-picker-label"
}
const _hoisted_3 = { class: "sr-only" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_v_icon = _resolveComponent("v-icon")!
  const _component_v_text_field = _resolveComponent("v-text-field")!
  const _component_v_color_picker = _resolveComponent("v-color-picker")!
  const _component_v_card_text = _resolveComponent("v-card-text")!
  const _component_v_card = _resolveComponent("v-card")!
  const _component_v_menu = _resolveComponent("v-menu")!

  return (_openBlock(), _createBlock(_component_v_menu, {
    "close-on-content-click": false,
    "close-on-back": "",
    location: "top",
    "min-width": "0px",
    offset: "15"
  }, {
    activator: _withCtx(({ props: menuProps }) => [
      _createElementVNode("div", _mergeProps({
        "aria-label": `Open color picker. Current color: ${_ctx.modelValue || 'white'}`,
        class: _ctx.colorPickerClasses,
        role: "button",
        tabindex: "0"
      }, menuProps, {
        onClick: _cache[1] || (_cache[1] = _withModifiers(() => {}, ["stop"]))
      }), [
        (_ctx.label)
          ? (_openBlock(), _createElementBlock("label", _hoisted_2, _toDisplayString(_ctx.label), 1))
          : _createCommentVNode("", true),
        _createVNode(_component_v_text_field, {
          "aria-label": _ctx.label || _ctx.placeholder,
          disabled: _ctx.disabled,
          "model-value": _ctx.modelValue,
          placeholder: _ctx.placeholder,
          flat: "",
          readonly: "",
          variant: "outlined",
          "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => (_ctx.$emit('update:modelValue', $event)))
        }, _createSlots({
          prepend: _withCtx(() => [
            _createElementVNode("div", {
              style: _normalizeStyle({ backgroundColor: _ctx.modelValue || '#FFFFFF' }),
              class: "gs-color-picker-swatch"
            }, [
              _createElementVNode("span", _hoisted_3, _toDisplayString(_ctx.modelValue || 'white'), 1)
            ], 4)
          ]),
          _: 2
        }, [
          (_ctx.clearable && _ctx.modelValue && !_ctx.disabled)
            ? {
                name: "append",
                fn: _withCtx(() => [
                  _createVNode(_component_v_icon, {
                    "aria-label": "Clear color selection",
                    icon: "mdi-close",
                    role: "button",
                    size: "small",
                    tabindex: "0",
                    onClick: _withModifiers(_ctx.handleClear, ["stop"])
                  }, null, 8, ["onClick"])
                ]),
                key: "0"
              }
            : undefined
        ]), 1032, ["aria-label", "disabled", "model-value", "placeholder"])
      ], 16, _hoisted_1)
    ]),
    default: _withCtx(() => [
      _createVNode(_component_v_card, null, {
        default: _withCtx(() => [
          _createVNode(_component_v_card_text, { class: "pa-0" }, {
            default: _withCtx(() => [
              _createVNode(_component_v_color_picker, {
                "aria-label": `Color picker for ${_ctx.label || 'color selection'}`,
                "model-value": _ctx.modelValue,
                modes: _ctx.allowedColorModes,
                "onUpdate:modelValue": _ctx.handleColorChange
              }, null, 8, ["aria-label", "model-value", "modes", "onUpdate:modelValue"])
            ]),
            _: 1
          })
        ]),
        _: 1
      })
    ]),
    _: 1
  }))
}